import React from 'react';
import '../../../assets/styles/components/summer-banner.scss';
import getResizeImageUrl from "../../../services/utils/getResizeImageUrl";


const SummerBanner = ({title, subTitle, image}) => {


    return(
        <div className={'summer-banner'}>
            <img alt={''} src={getResizeImageUrl({
                imageCabinId: image
            })} />

            <div className={'banner-content-bg'}>
                <h3 dangerouslySetInnerHTML={{__html: title}}/>
                <h5 dangerouslySetInnerHTML={{__html: subTitle}}/>
            </div>
        </div>
    );
};

export default React.memo(SummerBanner);
